import { useMutation, useQueryClient } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useToast } from '@/hooks/use-toast';
import { PayrollAdjustmentItem } from '@/hooks/useTeacherPayroll';

export function useUpdatePayrollAdjustments() {
  const queryClient = useQueryClient();
  const { toast } = useToast();

  return useMutation({
    mutationFn: async ({
      reportId,
      adjustments,
    }: {
      reportId: string;
      adjustments: PayrollAdjustmentItem[];
    }) => {
      const total = adjustments.reduce(
        (sum, item) => sum + (item.type === 'income' ? item.amount : -item.amount),
        0,
      );

      const { error } = await supabase
        .from('teacher_monthly_reports')
        .update({
          extra_adjustments: adjustments as unknown as object[],
          extra_adjustments_total: total,
          updated_at: new Date().toISOString(),
        })
        .eq('id', reportId);

      if (error) throw error;
      return { adjustments, total };
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['teacher-payroll'] });
    },
    onError: (error: Error) => {
      toast({ title: 'เกิดข้อผิดพลาด', description: error.message, variant: 'destructive' });
    },
  });
}
